import { ENDPOINTS } from '../utils/endpoints'
import { getAPIwithToken } from '../utils/fetchApi'

export interface ApiSubModule {
  id: number
  name: string
  slug: string
  sortOrder?: number
  permissions?: string[]
}

export interface ApiModule {
  id: number
  name: string
  slug: string
  icon: string
  sortOrder?: number
  permissions?: string[]
  subModules?: ApiSubModule[]
}

export interface GetModulesResponse {
  success: boolean
  message?: string
  data: ApiModule[]
}

export async function getModulesList(): Promise<GetModulesResponse> {
  return getAPIwithToken<GetModulesResponse>(ENDPOINTS.MODULES_LIST)
}
